<template>
    <div>
        <Banner :banners="banners" show-overlay class="green"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green">
            <h2 class="title text-center" v-text="result.name">
                第一場記者會宣傳活動
            </h2>
            <div class="alert alert-light text-sm text-center">
                <div v-html="result.description">
                    遊戲關卡共分3關: <br />
                    1.川閱古今:點擊兩則AR遊戲，找尋老照片資訊<br />
                    2.治水小尖兵:認識LID衝擊工法<br />
                    3.柳川知識王:分數達到60分，即算挑戰成功
                </div>
            </div>
            <ul>
                <li v-for="(g, index) in result.games" :key="index">
                    <a href="" class="d-block" @click.prevent="openGame(g)">
                        <div class="reward-img-wrapper">
                            <div class="img-wrapper">
                                <img
                                    :src="
                                        isPass(g.gameId) ? ImgPass : ImgNoPass
                                    "
                                    alt="穿越古今"
                                />
                            </div>
                            <div class="card-body">
                                <div class="title" v-text="g.name">
                                    穿越古今!老照片大蒐集
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <button
                class="btn btn-more w-100 d-block my-3"
                @click="exchange"
                :disabled="isExchange"
                v-if="isAllPass"
            >
                {{ !!isExchange ? '已兌換' : '兌換通關證書' }}
            </button>
        </div>
        <!-- Modal -->
        <div
            class="modal fade"
            id="citationModal"
            tabindex="-1"
            aria-labelledby="citationModalLabel"
            aria-hidden="true"
            ref="modal"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">兌換通關證書</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="edit-content">
                            <label for="detail_name" class="label">姓名</label>
                            <input
                                type="text"
                                class="form-control"
                                id="detail_name"
                                v-model="detail.name"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            取消
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="submit"
                        >
                            完成
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import { apiGetOpenApiCollectionDetail } from '@/plugin/api';
import ImgPass from '@/assets/pass.png';
import ImgNoPass from '@/assets/noPass.png';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            detail: {
                name: '',
                photoId: '',
            },
            result: {},
            pass: [],
            isExchange: false,
            ImgPass,
            ImgNoPass,
        };
    },
    created() {
        this.pass = [
            ...new Set(
                JSON.parse(
                    localStorage.getItem(
                        `${this.$route.params?.id}_pass_game`,
                    ) ?? JSON.stringify([]),
                ),
            ),
        ];
        this.isExchange = JSON.parse(
            localStorage.getItem(`${this.$route.params?.id}_is_exchange`)
                ?? JSON.stringify(false),
        );
    },
    async mounted() {
        document.querySelector('body').appendChild(this.$refs.modal);
        this.setLoading(true);
        await this.query();
        this.setLoading(false);
    },
    beforeDestroy() {
        document.querySelector('body').removeChild(this.$refs.modal);
    },
    computed: {
        isAllPass() {
            return this.result.games?.length === this.pass.length;
        },
    },
    methods: {
        goView(link, params) {
            this.$router
                .push({
                    path: `${this.$route.path}/${link}`,
                    query: {
                        ...params,
                    },
                })
                .catch(() => {});
        },
        exchange() {
            this.commonConfirm(
                '兌換通關證書將會顯示(今天)的日期，是否確定要兌換證書?',
                this.showCitationModal,
                true,
            );
        },
        showCitationModal() {
            $('#citationModal').modal('show');
        },
        hideCitationModal() {
            $('#citationModal').modal('hide');
        },
        submit() {
            if (!this.detail.name) {
                this.commonConfirm('您未輸入姓名，請確認。');
                return;
            }
            /**
             * 字數限制:
             * 全型+中文最大長度6
             * 半形最大長度12
             * */
            if (this.getStrLength(this.detail.name) > 12) {
                this.commonConfirm(
                    '姓名限制:<br>全型+中文最大長度:6<br>半形最大長度:12<br>',
                );
                return;
            }
            this.hideCitationModal();
            this.isExchange = true;
            this.goView('certificate', this.detail);
        },
        openGame(game) {
            if (!this.pass.includes(game.gameId)) {
                this.pass.push(game.gameId);
            }
            localStorage.setItem(
                `${this.$route.params?.id}_pass_game`,
                JSON.stringify(this.pass),
            );
            window.open(game.url, '_blank');
        },
        query() {
            return apiGetOpenApiCollectionDetail(this.$route.params.id).then(
                (ret) => {
                    if (ret.data?.success) {
                        this.result = ret.data.data;
                        this.detail.photoId = this.result.photoId;
                    } else {
                        this.commonAlert(ret.data?.message);
                    }
                },
            );
        },
        isPass(id) {
            return this.pass.includes(id);
        },
        /**
         * 取得字串長度
         * @param {String} 解析字串
         */
        getStrLength(text) {
            // 計算規則:中文和全形均認為2個半形
            return text
                .replace(/[\uff00-\uffff]/g, '**')
                .replace(/[\u4e00-\u9fa5]/g, '**').length;
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
